"use strict";
// TODO:: remove usages
// old service, cryptojs was not updated in 10 years. use encryption-service.js
const { Crypto } = require('cryptojs');
const encrypt = (str, password) => {
    const mode = new Crypto.mode.ECB(Crypto.pad.pkcs7);
    const bytes = Crypto.charenc.UTF8.stringToBytes(str);
    const encrypted = Crypto.DES.encrypt(bytes, password, { asBytes: true, mode });
    return Crypto.util.bytesToHex(encrypted);
};
const decrypt = (str, password) => {
    const mode = new Crypto.mode.ECB(Crypto.pad.pkcs7);
    const bytes = Crypto.util.hexToBytes(str);
    const decrypted = Crypto.DES.decrypt(bytes, password, { asBytes: true, mode });
    return Crypto.charenc.UTF8.bytesToString(decrypted);
};
module.exports = {
    encrypt,
    decrypt,
};
//# sourceMappingURL=cryptoServiceDeprecated.js.map